export const SPARKLINE_CHART_DEFAULT_PROPS = {
  margin: { bottom: 2, left: 2, right: 2, top: 2 },
}

export const SPARKLINE_AREA_DEFAULT_PROPS = {
  activeDot: { r: 3, strokeWidth: 0 },
  dot: false,
  fillOpacity: 0.14,
  isAnimationActive: false,
  strokeWidth: 2,
  type: 'monotone',
}

// Normalized to its own range, so a small drift still reads as a trend.
export const SPARKLINE_Y_AXIS_DEFAULT_PROPS = {
  domain: ['dataMin', 'dataMax'],
  hide: true,
}

export const SPARKLINE_TOOLTIP_DEFAULT_PROPS = {
  allowEscapeViewBox: { x: true, y: true },
  cursor: false,
}
